<template>
  <div>
    <defaultnavbar :login="login" :user="user" :notificationCount="notificationCount"/>
    <div class="ib-main-box">
      <router-view></router-view>
    </div>
    <defaultfooter/>
  </div>
</template>

<script>
  import defaultnavbar from '@/components/Navbar/DefaultNavbar';
  import defaultfooter from '@/components/Footer/DefaultFooter';

  export default {
    name: 'LayoutDefault',
    data: function () {
      return {
        login: false,
        user: {},
        notificationCount: 0,
        notificationStepCount: 2,
      }
    },
    components: {
      defaultnavbar,
      defaultfooter
    },
    created() {
      const self = this;

      if(self.$store.getters.isAuthenticated) {
        self.login = true;
        self.user = self.$store.getters.getUser;
      }
      if (self.login == true){
        self.GetNotifications();
      }
      this.$root.$on('updateUser', () => {
        self.user = self.$store.getters.getUser;
        self.login = true;
      })
      this.$root.$on('updateNotificationCount', (count) => {
        const self = this;
        self.notificationCount = count;
      })
    },
    methods: {
      async GetNotifications() {
        const self = this;
        localStorage.setItem('NotificationPaginate', self.notificationStepCount);
        await axios.get('customer/notifications/user_notifications?current_page=1&paginate=yes&order_sort=desc&per_page=' + self.notificationStepCount).then(function (resp) {
          if (resp.data.code == 200) {
            self.notifications = {};
            self.notifications = resp.data.data.notifications;
            self.notificationCount = self.notifications.filter(x => x.is_read === 0 );
            if(self.notificationCount.length > 9){
              self.notificationCount  = '9+';
            }else{
              self.notificationCount = self.notificationCount.length;
            }
          }
        }).catch(function (resp) {
          $toast.error(resp.data.message, {position: 'top-right'})
        });
      },
    },
    beforeDestroy() {
      this.$root.$off('updateUser');
      this.$root.$off('updateNotificationCount');
    }
  }
</script>



// WEBPACK FOOTER //
// src/layouts/default.vue